<!-- 疫情专题 -->
<template>
<div class="outbreak">
    <Header />

    <div class="outbreak-warrp">
        <div class="banner"><img src="https://media5.imgyb.xyz/media/v1/image/54a31f7f924d063bc1a2da3d50029f3d.png" alt=""></div>
        <div class="outbreak-cont">
            <div class="dynamic" v-if="!outbreakLoading">
                <div class="page-common-title">
                    <div class="title"><strong>加拿大疫情动向</strong></div>
                    <div class="subf-info">截止 {{Date.now()|torontoTimeFormat('YYYY-MM-DD')}} 多伦多时间</div>
                </div>
                <div class="static">
                    <div class="item first">
                        <div class="new-add ">昨日 <span>+{{ outbreak.yesterdayCanadaAffirm }}</span></div>
                        <div class="all-count">{{ outbreak.allCanadaAffirm }}</div>
                        <div class="lab-text">全国确诊</div>
                    </div>
                    <div class="item second">
                        <div class="new-add">昨日 <span>+{{ outbreak.yesterdayOntarioAffirm }}</span></div>
                        <div class="all-count">{{ outbreak.allOntarioAffirm }}</div>
                        <div class="lab-text">安省确诊</div>
                    </div>
                    <div class="item third">
                        
                        <div class="all-count">{{ outbreak.allCanadaCure }}</div>
                        <div class="lab-text">全国治愈</div>
                    </div>
                    <div class="item">
              
                        <div class="all-count">{{ outbreak.allCanadaDead }}</div>
                        <div class="lab-text">全国死亡</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="outbreak-cont">
            <div class="page-common-title">
                <div class="title"><strong>加拿大数据概览</strong></div>
                <!-- <div class="subf-info">数据来源：官方公开数据</div> -->
            </div>
            <table class="outbreak-table">
                <thead>
                    <tr>
                        <td>省市</td>
                        <td>累计确诊</td>
                        <td>现有确诊</td>
                        <td>治愈</td>
                        <td>死亡</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in tableData" :key="item.city+'-'+index">
                        <td>{{item.city}}</td>
                        <td><div class="color-red">{{item.totalAffirm}}</div></td>
                        <td><div class="color-origan">{{item.nowAffirm}}</div></td>
                        <td><div class="color-green">{{item.cured}} </div></td>
                        <td>{{item.dead}}</td>
                    </tr>
                </tbody>
            </table>
            <!-- <el-table :data="tableData" class="outbreak-table">
                <el-table-column label="省市" width="60">
                    <template slot-scope="{}">
                        <div>安省</div>
                    </template>
                </el-table-column>
                <el-table-column label="累计确诊">
                    <template slot-scope="{}">
                        <div class="color-red">1277205</div>
                    </template>
                </el-table-column>
                <el-table-column label="现有确诊">
                    <template slot-scope="{}">
                        <div class="color-origan">1277205</div>
                    </template>
                </el-table-column>
                <el-table-column label="治愈/死亡">
                    <template slot-scope="{}">
                        <div class="color-green">1277205 </div>
                        
                    </template>
                </el-table-column>
                <el-table-column label="死亡">
                    <template slot-scope="{}">
                        12991
                    </template>
                </el-table-column>
            </el-table> -->
        </div>
        <div class="outbreak-cont">
            <!-- <div class="page-common-title">
                <div class="title"><strong>加拿大疫情累计确诊趋势图</strong></div>
            </div> -->
            <div class="view-echarts" ref="viewEcharts" style="height:300px"></div>
        </div>

        <div class="outbreak-cont">
            <div class="page-common-title">
                <div class="title"><strong>最新报道</strong></div>
               
            </div>
             <div class="last-news">
                <LastNewsItem v-for="item in lastNews" :key="item.id" :post="item"  />
            </div>
        </div>
        <div class="outbreak-cont">
            <div class="page-common-title">
                <div class="title"><strong>热门话题</strong></div>
               
            </div>
             <div class="last-news">
                <ItemSubject v-for="item in subjectList" :key="item.id" :data="item"  />
            </div>

            <div class="loading-style" v-if="hasMore && subjectListLoading"><i class="el-icon-loading"></i> 加载中</div>
        </div>
    </div>
</div>
</template>
<script>
//import NoteAndPmHead from '@/components/noteAndPmHead.vue'
import { throttle } from 'throttle-debounce';
import Header from '@/components/header/header.vue'
import * as echarts from 'echarts/core';
import LastNewsItem from './last-news-item.vue'
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  DataZoomComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';
import ItemSubject from './item-subject.vue'
import { isScrollToPageBottom } from '@/utils/utils';
export default {
    name:'OutbreakIndex',
    components:{Header,LastNewsItem,ItemSubject},
    data(){
        return {
            tableData:[],
            outbreakLoading:true,
            outbreak:{},
            viewData:[],
            lastNews:[],
            subjectList:[],
            params:{   
                "offset": 1,
                "size": 10,
                //"sort": ["property_thumbUpTotal: DESC","property_updatedAt: DESC"],
                "sort":['property_commentedAt: DESC'],
                "subject": [
                    "cdb31301-33e6-428e-8133-613e92670a33"
                ],
                //"options":{"elite":[1]},    
            },
            hasMore:true,
            subjectListLoading:false
        }
    },
    created(){
        echarts.use([
            TitleComponent,
            ToolboxComponent,
            TooltipComponent,
            GridComponent,
            LegendComponent,
            LineChart,
            CanvasRenderer,
            UniversalTransition,
            DataZoomComponent
        ]);
        this.getData();
        this.getTableData();
        this.getLastNews();
        this.getSubjectList();
    },
    methods:{
        async getData(){
            let result = await this.$axios.post('/user/v1/single/get/config',{
                "group": "homePage",
                "dataId": "canadaCOVID19Data",
                "from": "mem",
                "outType": "json"
            });
            this.outbreakLoading = false;
            
            if( result.code == 0 ){
          
                this.outbreak = result.data
            }
        },
        async getTableData(){
            let result = await this.$axios.post('/user/v1/single/get/config',{
                "group": "homePage",
                "dataId": "canadaCOVID19ProvData",
                "from": "mem",
                "outType": "json"
            });
            this.tableData = result.data;
            
        },
        async getViewData(){
            let result = await this.$axios.post('/user/v1/single/get/config',{
                "group": "homePage",
                "dataId": "canadaCOVID19DayData",
                "from": "mem",
                "outType": "json"
            });
            
            this.viewData = result.data
        },
        async getLastNews(){
            let result = await this.$axios.post('/cms/v1/get/subject/list/data',{
                offset:1,
                size:10,
                keyword:'加拿大疫情'
            })
            
            this.lastNews = result.data.items;
        },
        async getSubjectList(){
            this.subjectListLoading = true;
            let result = await this.$axios.post('/bbs/v1/get/post/list/for/subject',this.params);
      
            this.subjectListLoading = false;

            if( result.code == 0 ){
                
                this.subjectList = this.subjectList.concat(result.data.items);
                this.hasMore = result.data.itemTotal != this.subjectList.length;
            }
        },
        pageScroll: throttle(300, function () {
            if( isScrollToPageBottom()  && this.hasMore && !this.subjectListLoading ){
                this.params.offset ++;
                this.getSubjectList();
            }

            /* const scrollTop = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;
            const offsetTop = this.$refs.tab.offsetTop;
            this.tabFixed = scrollTop >= offsetTop; */
        }),
    },
    async mounted(){
        await this.getViewData();
        let legendArr = [];
        let xAxisArray = [];
        let seriesArray = [];
        for(var i=0; i<this.viewData.length; i++){
            let itemData = this.viewData[i].data;
            for(var l=0; l<itemData.length; l++){
                let pieData = itemData[l];
                if( i==0){
                    seriesArray.push({
                        name: pieData.city,
                        type: 'line',
                        //stack: 'y',
                        //symbolSize:20,
                        data: []
                    });
                    
                    legendArr.push(pieData.city);
                }

                seriesArray[l].data.push(pieData.totalAffirm)

            }
            xAxisArray.push(this.viewData[i].day);
        }
     /*    console.log('legendArr',legendArr);
        console.log('xAxisArray',xAxisArray);
        console.log('seriesArray',seriesArray); */
        var chartDom = this.$refs.viewEcharts;
        


        var myChart = echarts.init(chartDom, null, {
            renderer: 'canvas',
            useDirtyRect: false
        });
        var option;

        option = {
            title: {
                text: '加拿大疫情累计确诊趋势图'
            },
            tooltip: {
                trigger: 'axis'
            },
            legend: {
                //right:'auto',
                left:'right',
                //data: ['Email', 'Union Ads', 'Video Ads', 'Direct', 'Search Engine']
                data:legendArr
            },
            dataZoom: [
                {
                    type: 'slider',
                    xAxisIndex: 0,
                    filterMode: 'none'
                },
               
                /* {
                    type: 'inside',
                    xAxisIndex: 0,
                    filterMode: 'none'
                }, */
              
            ],
            grid: {
                left: '3%',
                right: '4%',
                bottom: '3%',

                containLabel: true
            },
            /* toolbox: {
                feature: {
                    saveAsImage: {}
                }
            }, */
            xAxis: {
                type: 'category',
                boundaryGap: false,
                //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
                data:xAxisArray,
                //axisLine: { onZero: false },
                //min:xAxisArray[0],
                //max:xAxisArray[xAxisArray.length-1]
            },
            yAxis: {
                type: 'value'
            },
            series:seriesArray
            /* series: [
                {
                name: 'Email',
                type: 'line',
                stack: 'Total',
                data: [120, 132, 101, 134, 90, 230, 210]
                },
                {
                name: 'Union Ads',
                type: 'line',
                stack: 'Total',
                data: [220, 182, 191, 234, 290, 330, 310]
                },
                {
                name: 'Video Ads',
                type: 'line',
                stack: 'Total',
                data: [150, 232, 201, 154, 190, 330, 410]
                },
                {
                name: 'Direct',
                type: 'line',
                stack: 'Total',
                data: [320, 332, 301, 334, 390, 330, 320]
                },
                {
                name: 'Search Engine',
                type: 'line',
                stack: 'Total',
                data: [820, 932, 901, 934, 1290, 1330, 1320]
                }
            ] */
        };

        option && myChart.setOption(option);
        window.addEventListener('resize', myChart.resize);

        window.addEventListener('scroll', this.pageScroll);

        this.$once('hook:beforeDestroy', () => {
            window.removeEventListener('scroll', this.pageScroll);
        });
    }
}
</script>
<style lang="less" scoped>
.outbreak{background: #f8f8f8;
    &:after{content: ''; display: table; clear: both;}
}
.banner{margin-bottom: 10px;}
.outbreak-cont{padding: 10px; background: #fff; border-radius: 5px; margin:0 10px 10px;}
@media screen and (min-width:768px){
    .outbreak{min-width:1200px}
    .outbreak-warrp{width:750px; margin:0 auto} 
    .outbreak-cont{margin: 0 0 20px; padding: 20px;}
}

.page-common-title{
    display: flex; align-items: center;margin-bottom: 15px; height: 20px;
    .title{margin-right: 5px;font-size: 16px; } 
    .subf-info{color: #999;font-size: 12px;}
}
.dynamic{
  
    .static{
        display: flex; 
        .item{
            flex:1; display: flex; flex-direction: column; justify-content: flex-end; align-items: center; position: relative;
            &:after{content:''; position: absolute; width: 2px; height: 70%; background: #eee; right: 0; top: 15%;}
            &:last-child:after{display: none;}
            .new-add{
                font-size: 12px; margin-bottom: 5px; color: #999 ;
            }
            .all-count{font-size: 20px; margin-bottom: 5px; font-weight: bold; color: #111;}
            .lab-text{color: #666; font-size: 14px;}
            &.first{
                .new-add{
                    span{color: #E43A3A;}
                }
                .all-count{color: #E43A3A;}
            }
            &.second{
                .new-add{
                    span{color: #01A07A;}
                }
                .all-count{color: #EC9217;}
            }
            &.third{
                .all-count{color: #01A07A;}
            }
        }
    }
}

.outbreak-table{
    width: 100%; border-spacing: 0; font-size: 12px;
    td{padding:8px 5px;line-height: 20px;}
    thead{
        td{ color: #333; padding: 0 5px;}
    }
    tbody{
        tr:nth-child(2n){
            background: #f8f8f8;  
        }
    }
    .color-red{color: #E43A3A;}
    .color-origan{color: #EC9217;}
    .color-green{color: #01A07A;}
}
@media screen and (min-width:768px){
    .banner{margin-bottom: 20px;}
    .page-common-title{
        line-height: 1.5;
        .title{font-size: 18px; } 
        .subf-info{font-size: 14px;}
    }
    .dynamic{
  
        .static{
          
            .item{
              
                .new-add{font-size: 14px; margin-bottom: 10px;}
                .all-count{font-size: 26px;margin-bottom: 10px; }
                .lab-text{ font-size: 16px;}
                
            }
        }
    }
    .outbreak-table{
        font-size: 16px; line-height: 24px;
        td{padding:10px 5px; line-height: 24px;}
    }
}

.loading-style{display: flex; margin-bottom: 20px; color: #999; justify-content: center ; align-items: center; font-size: 12px;
    i{margin-right: 5px;}
}
</style>